export default __webpack_public_path__ + "static/media/ipa.7b8558b0.jpg";